import { render, staticRenderFns } from "./CreditNoteList.vue?vue&type=template&id=67b2980c"
import script from "./CreditNoteList.vue?vue&type=script&lang=js"
export * from "./CreditNoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports